<template>
  <v-layout
    row
    wrap
    class="dateTimePicker"
    @click="openPicker"
  >
    <div class="subheading">
      {{ title }}:
    </div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :nudge-right="40"
      :return-value.sync="date"
      class="pl-2"
      lazy
      transition="scale-transition"
      offset-y
    >
      <p
        slot="activator"
        class="mb-0"
      >
        <v-flex
          d-flex
          align-center
        >
          <v-icon color="iconColor">
            event
          </v-icon>
          <span
            v-if="formattedDate"
            class="pl-2 subheading"
          >
            {{ formattedDate }}
          </span>
          <span
            v-else
            class="pl-2 subheading"
          >
            Select Date
          </span>
        </v-flex>
      </p>
      <v-date-picker
        v-model="date"
        :max="maxDate"
        :min="minDate"
        type="date"
        no-title
        scrollable
      >
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="saveDate"
        >
          OK
        </v-btn>
      </v-date-picker>
    </v-menu>
    <v-menu
      ref="menu2"
      v-model="menu2"
      :close-on-content-click="false"
      :nudge-right="40"
      class="pl-2"
      lazy
      transition="scale-transition"
      offset-y
    >
      <p
        slot="activator"
        class="mb-0"
        @click.stop="menu2 = true"
      >
        <v-flex
          d-flex
          align-center
        >
          <v-icon color="iconColor">
            access_time
          </v-icon>
          <span
            v-if="formattedTime"
            class="pl-2 subheading"
          >
            {{ formattedTime }}
          </span>
          <span
            v-else
            class="pl-2 subheading"
          >
            Select Time
          </span>
        </v-flex>
      </p>
      <v-time-picker
        v-model="time"
        :max="maxTime"
        :min="minTime"
        :allowed-minutes="allowedSteps"
        scrollable
      >
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="menu2 = false"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="saveTime"
        >
          OK
        </v-btn>
      </v-time-picker>
    </v-menu>
  </v-layout>
</template>
<script>
import * as moment from 'moment';

export default {
  name: 'DateTimePicker',
  model: {
    prop: 'dateTime',
    event: 'change'
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    dateTime: {
      type: String,
      default: null
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    allowedMinuteSteps: {
      type: Number,
      default: null
    },
    showPlaceholder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      menu2: false,
      formattedDate: null,
      formattedTime: null,
      date: '',
      time: '',
      maxDate: '',
      minDate: '',
      maxTime: '',
      minTime: '',
      allowedSteps: null
    };
  },
  created() {
    this.date = moment().format('YYYY-MM-DD');
    this.setTime();
    this.setMaxDateTime();
    this.setMinDateTime();
    if (!this.showPlaceholder) {
      this.formatDate(this.date);
      this.formattedTime = moment().format('hh:mm A');
    }
  },
  methods: {
    openPicker() {
      this.menu = true;
    },
    formatDate(date) {
      this.formattedDate = moment(date, ['YYYY-MM-DD']).format('DD MMM YYYY');
    },
    setMaxDateTime() {
      if (!this.max) return;
      this.maxDate = moment(this.max).format('YYYY-MM-DD');
      this.maxTime = moment(this.max).format('HH:mm');
    },
    setMinDateTime() {
      if (!this.min) return;
      this.minDate = moment(this.min).format('YYYY-MM-DD');
      this.minTime = moment(this.min).format('HH:mm');
    },
    setMinTime() {
      if (!this.min) return;
      const today = moment(this.date, ['YYYY-MM-DD']).isSame(
        moment().format('YYYY-MM-DD')
      );
      if (!today) {
        this.minTime = moment()
          .startOf('day')
          .format('HH:mm');
      } else {
        this.minTime = moment(this.min).format('HH:mm');
      }
    },
    setMaxTime() {
      if (!this.max) return;
      const today = moment(this.date, ['YYYY-MM-DD']).isSame(
        moment().format('YYYY-MM-DD')
      );
      if (!today) {
        this.maxTime = moment()
          .endOf('day')
          .format('HH:mm');
      } else {
        this.maxTime = moment(this.max).format('HH:mm');
      }
    },
    setTime() {
      if (this.allowedMinuteSteps) {
        this.allowedSteps = m => m % this.allowedMinuteSteps === 0;
        this.time = moment(this.roundTo(this.allowedMinuteSteps)).format(
          'HH:mm'
        );
      } else {
        this.time = moment().format('HH:mm');
      }
    },
    roundTo(val) {
      const minutes = moment().minutes();
      const addedMin = val - (minutes % val);
      return moment().add(addedMin, 'minutes');
    },

    saveDate() {
      this.$refs.menu.save(this.date);
      this.formatDate(this.date);
      if (this.formattedTime !== ' Select Time') {
        const time = moment(this.formattedTime, ['hh:mm A']).format('HH:mm');
        this.convertDateTime(this.date, time);
      }
      this.menu2 = true;
      this.setMinTime();
      this.setMaxTime();
    },
    saveTime() {
      this.$refs.menu2.save(this.time);
      this.formattedTime = moment(this.time, ['HH:mm']).format('hh:mm A');
      this.convertDateTime(this.date, this.time);
    },
    convertDateTime(date, time) {
      if (!time) return;
      const DateTime = moment(`${date} ${time}`, ['YYYY-MM-DD HH:mm']).format(
        'YYYY-MM-DD HH:mm'
      );
      this.$emit('change', DateTime);
    }
  }
};
</script>
<style scoped>
.dateTimePicker:hover {
  cursor: pointer;
}
</style>

